module.exports = __webpack_public_path__ + "img/reward-box01-pc.022fffa7.png";